import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from 'app/components/utils/Constants';
import { Log } from 'app/core/logging/log';
import { ConfigModel } from 'app/models/config-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';

@Component({
  selector: 'app-admin-maintenance',
  templateUrl: './admin-maintenance.page.html',
  styleUrls: ['./admin-maintenance.page.scss'],
})
export class AdminMaintenancePage implements OnInit {
  cleaningCodeForm!: FormGroup;
  cleaningConfig?: ConfigModel;
  savingCleaningCode = false;
  erasingReservationData = false;

  constructor(
    private restService: RestService,
    private appService: AppService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.cleaningCodeForm = this.fb.group({
      cleaningCode: ['', [Validators.required, Validators.maxLength(50)]]
    });
    this.loadCleaningCode();
  }

  executeSync(direction: string, data: any) {
    if (!confirm("Esta seguro de realizar la acciÃ³n?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.executeSync(direction, data).subscribe(() => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    });
  }

  sendAction(action: string, param?: any) {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.sendAction(action, param).subscribe(() => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    });
  }

  boxexCleaning(lockerType: string) {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.boxesCleaning(lockerType).subscribe(() => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    });
  }

  eraseKioskReservationData() {
    const confirmed = confirm(
      'Esta acción eliminará del kiosco todos los datos relacionados con las reservas, incluidos reservas, pagos, tickets y cualquier otra información asociada. Esta operación no se puede deshacer. ¿Desea continuar?'
    );

    if (!confirmed) {
      return;
    }

    this.erasingReservationData = true;
    this.restService.reservationErase().subscribe({
      next: () => {
        this.erasingReservationData = false;
        this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      },
      error: () => {
        this.erasingReservationData = false;
        this.appService.showDangerToast(Constants.MSG_DANGER);
      }
    });
  }

  saveCleaningCode() {
    if (!confirm('Esta seguro de realizar la accion?')) {
      return;
    }

    if (this.cleaningCodeForm.invalid) {
      this.cleaningCodeForm.markAllAsTouched();
      this.appService.showDangerToast('Revise el codigo de limpieza antes de guardar.');
      return;
    }

    const payload: ConfigModel = {
      id: this.cleaningConfig?.id,
      key: 'CLEANING_CODE',
      value: String(this.cleaningCodeForm.get('cleaningCode')?.value ?? '').trim(),
      type: this.cleaningConfig?.type ?? 'string',
      description: this.cleaningConfig?.description ?? 'Codigo interno para operaciones de limpieza.',
      dataSource: this.cleaningConfig?.dataSource ?? 'SERVER',
      encrypted: this.cleaningConfig?.encrypted ?? false,
      editable: this.cleaningConfig?.editable ?? true,
      restriction: this.cleaningConfig?.restriction ?? { frontend: 'input', min: 1, max: 50, type: 'string' }
    };

    this.savingCleaningCode = true;
    const request = this.cleaningConfig?.id
      ? this.restService.putConfig(payload)
      : this.restService.postConfig(payload);

    request.subscribe({
      next: () => {
        this.loadCleaningCode();
        this.savingCleaningCode = false;
        this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      },
      error: () => {
        this.savingCleaningCode = false;
        this.appService.showDangerToast(Constants.MSG_DANGER);
      }
    });
  }

  private loadCleaningCode() {
    this.restService.getConfigs().subscribe(result => {
      this.cleaningConfig = result.find((config: ConfigModel) => config.key === 'CLEANING_CODE');
      this.cleaningCodeForm.patchValue({
        cleaningCode: this.cleaningConfig?.value ?? ''
      }, { emitEvent: false });
    });
  }
}
